import { useEffect, useState } from "react";
import { X, Plus, Save } from "lucide-react";
import { toast } from "sonner";
import { api, CURRENCIES, errMsg, PROJECT_STATUSES } from "../api";
import { useAuth } from "../auth";
import { myCompaniesOf } from "./CompanyScopeBar";

const EMPTY = {
  project_no: "", name: "", employer_short: "", investor_short: "", city: "", district: "",
  capacity: "", responsible: "", company: "", agreed_amount: "", paid_amount: "0",
  currency: "TRY", vat_included: true, status: "Planlama", deal_type: "lump",
};

export default function NewProjectModal({ close, refresh, project }) {
  const { user } = useAuth();
  const myCompanies = myCompaniesOf(user);
  const isEdit = !!project?.id;
  const [form, setForm] = useState(() => isEdit ? Object.fromEntries(Object.keys(EMPTY).map((k) => [k, project[k] ?? (k === "vat_included" ? true : "")])) : EMPTY);
  const [employers, setEmployers] = useState([]);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  useEffect(() => { api.get("/employers").then(r => setEmployers(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, agreed_amount: Number(form.agreed_amount) || 0, paid_amount: Number(form.paid_amount) || 0, project_no: form.project_no || null };
    try {
      if (isEdit) await api.put(`/projects/${project.id}`, payload); else await api.post("/projects", payload);
      toast.success(isEdit ? "Proje güncellendi" : "Proje portföye eklendi");
      close(); refresh?.();
    } catch (err) { toast.error(errMsg(err, "Proje kaydedilemedi")); }
  };

  return (
    <div className="modal-backdrop" onClick={close}>
      <div className="modal" onClick={(e) => e.stopPropagation()} data-testid="new-project-modal">
        <div className="modal-head">
          <div><span className="eyebrow">{isEdit ? "PROJEYİ DÜZENLE" : "YENİ KAYIT"}</span><h2>{isEdit ? project.name : "Yeni proje oluştur"}</h2></div>
          <button onClick={close} data-testid="close-modal-button"><X size={18} /></button>
        </div>
        <form onSubmit={submit}>
          <div className="form-grid">
            <label>Proje no<input value={form.project_no} onChange={set("project_no")} placeholder="1" data-testid="project-no-input" /></label>
            <label>Proje adı<input required value={form.name} onChange={set("name")} placeholder="Örn. Marina Konutları" data-testid="project-name-input" /></label>
          </div>
          <div className="form-grid">
            <label>İşveren
              <input required list="emp-list" value={form.employer_short} onChange={set("employer_short")} placeholder="EMÇ" data-testid="project-employer-input" />
              <datalist id="emp-list">{employers.map(e => <option key={e.id} value={e.short_name}>{e.name}</option>)}</datalist>
            </label>
            <label>Yatırımcı<input list="emp-list" value={form.investor_short} onChange={set("investor_short")} placeholder="EMÇ" data-testid="project-investor-input" /></label>
          </div>
          <div className="form-grid">
            <label>İl<input value={form.city} onChange={set("city")} data-testid="project-city-input" /></label>
            <label>İlçe<input value={form.district} onChange={set("district")} data-testid="project-district-input" /></label>
          </div>
          <div className="form-grid">
            <label>Kapasite<input value={form.capacity} onChange={set("capacity")} placeholder="15 MW" data-testid="project-capacity-input" /></label>
            <label>Sorumlu<input value={form.responsible} onChange={set("responsible")} data-testid="project-responsible-input" /></label>
            <label>Sorumlu Şirket
              <select value={form.company} onChange={set("company")} data-testid="project-company-select">
                <option value="">— Belirtilmemiş —</option>
                {myCompanies.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
          </div>
          <div className="form-grid">
            <label>Anlaşma Tipi
              <select value={form.deal_type} onChange={set("deal_type")} data-testid="project-dealtype-select">
                <option value="lump">Kırılımsız (tek işveren bedeli)</option>
                <option value="itemized">İş Kalemi Bazlı (kalem kalem işveren bedeli)</option>
              </select>
            </label>
            <label className="check-label"><input type="checkbox" checked={!!form.vat_included} onChange={set("vat_included")} data-testid="project-vat-checkbox" /> KDV dahil</label>
          </div>
          <div className="form-grid three">
            <label>{form.deal_type === "itemized" ? "Proje Bedeli (bilgi amaçlı)" : "İşveren Bedeli (gelir)"}<input required={form.deal_type !== "itemized"} type="number" step="0.01" value={form.agreed_amount} onChange={set("agreed_amount")} placeholder="0" data-testid="project-budget-input" /></label>
            <label>Tahsil Edilen<input type="number" step="0.01" value={form.paid_amount} onChange={set("paid_amount")} data-testid="project-paid-input" /></label>
            <label>Para birimi
              <select value={form.currency} onChange={set("currency")} data-testid="project-currency-select">{CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}</select>
            </label>
          </div>
          <div className="form-grid">
            <label>Durum
              <select value={form.status} onChange={set("status")} data-testid="project-status-select">{PROJECT_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}</select>
            </label>
          </div>
          <button className="new-btn full" type="submit" data-testid="save-project-button">
            {isEdit ? <Save size={16} /> : <Plus size={17} />} {isEdit ? "Değişiklikleri kaydet" : "Projeyi kaydet"}
          </button>
        </form>
      </div>
    </div>
  );
}
